import React from "react";
import { WorkerChannelResponse } from "../models/TwilioModels";
import { camelToTitleCase } from "../utils";
import { InlineValueDisplayList } from "./InlineValueDisplayList";

interface WorkerChannelsViewerProps {
	// The response received when loading channel data for the worker.
	workerChannels?: WorkerChannelResponse[];
}

/**
 * Takes an array of WorkerChannelResponse objects for the worker, and renders the names of the channels, together with
 * capacity and availabity of the worker for each channel.
 * @param props
 */
export const WorkerChannelsViewer = (props: WorkerChannelsViewerProps) => {
	function getChannelStatsNode(channel: WorkerChannelResponse) {
		return (
			<span
				style={{
					fontSize: 12,
					fontWeight: 400,
				}}
			>
				{channel.available ? "Available" : "Unavailable"}
				&nbsp; | Capacity:&nbsp;
				{channel.capacity}
			</span>
		);
	}

	function getChannelDisplayObjects() {
		return props.workerChannels!.map((c) => {
			return {
				label: camelToTitleCase(c.friendlyName),
				node: getChannelStatsNode(c),
				row: true,
			};
		});
	}

	function createChannelStats() {
		if (props.workerChannels) {
			return (
				<div style={{ fontSize: 14 }}>
					<InlineValueDisplayList displayItems={getChannelDisplayObjects()}></InlineValueDisplayList>
				</div>
			);
		} else {
			return <span>No channels found for worker.</span>;
		}
	}

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				marginLeft: 4,
				marginRight: 4,
				marginTop: 2,
			}}
		>
			{createChannelStats()}
		</div>
	);
};
